<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：加钟信息
  -->
	<div class="pb50" v-loading="loading">
		<div class="product-content">
			<!--商品信息-->
			<div class="common-form mt16">商品信息</div>
			<div class="table-wrap">
				<el-table size="small" :data="detail.product" border style="width: 100%">
					<el-table-column prop="product_id" label="订单ID"></el-table-column>
					<el-table-column prop="productNo" label="订单编号"></el-table-column>
					<el-table-column prop="total_price" label="支付金额"></el-table-column>
					<el-table-column prop="total_num" label="时长"></el-table-column>
					<el-table-column prop="productName" label="加钟项目" min-width="100">
						<template slot-scope="scope">
							<div class="product-info">
								<div class="info">
									<div class="name">{{ scope.row.productName }}</div>
									<div class="price">{{ scope.row.total_price }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column prop="createTime" label="支付时间"></el-table-column>			
				</el-table>
			</div>

			
			
			
		</div>
	</div>
</template>

<script>
	import OrderApi from '@/api/order.js';
	import {
		deepClone,
	} from '@/utils/base.js';
	export default {
		data() {
			return {
				/*是否加载完成*/
				loading: true,
				/*订单数据*/
				detail: {
					product: [],
				}	
			}
		},
		created(e) {
			/*获取列表*/
			this.getParams();
		},
		methods: {
			/*获取参数*/
			getParams() {
				let self = this;
				// 取到路由带过来的参数
				const params = this.$route.query.orderId;
				OrderApi.orderdetail({
							orderId: params
						},
						true
					)
					.then(data => {
						self.loading = false;
						self.detail = data.data.detail;
					})
					.catch(error => {
						self.loading = false;
					});
			}
		}
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/part/bell.vue